import { ListItem, ListItemButton } from "@mui/material";
import { useCallback } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

/** SideMenuコンポーネントで使用するListItemコンポーネント */
const SideMenuListItem = ({ path, children }) => {
    /** ロケーションを変更 */
    const history = useHistory();

    /** クリックするとき イベントハンドラ */
    const onClick = useCallback(() => history.push(path), [history, path]);

    return (
        <ListItem disablePadding>
            <ListItemButton onClick={onClick}>
                {children}
            </ListItemButton>
        </ListItem>
    );
};

export default SideMenuListItem;
